module.exports = __webpack_public_path__ + "static/media/shenzhen1@2x.a5cee93e.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/shenzhen1@2x.png
// module id = 1632
// module chunks = 0